export default __webpack_public_path__ + "static/media/building.4f0a308d.svg";